import { useSyncExternalStore } from 'react';

// Christmas decorations: on by themselves from 1 December to 6 January, unless the person has
// turned them off. The choice is kept per browser. To see them outside the season (e.g. on QA),
// run localStorage.setItem('festiveDecorations', 'preview') in the browser console.
const KEY = 'festiveDecorations';
const CHANGED = 'festive:change';

export const isFestiveSeason = (date = new Date()) => date.getMonth() === 11 || (date.getMonth() === 0 && date.getDate() <= 6);

const stored = () => {
  try {
    return localStorage.getItem(KEY);
  } catch (e) {
    return null;
  }
};

const subscribe = (onChange) => {
  window.addEventListener(CHANGED, onChange);
  window.addEventListener('storage', onChange);
  return () => {
    window.removeEventListener(CHANGED, onChange);
    window.removeEventListener('storage', onChange);
  };
};

/** { inSeason, on, setOn }: whether decorations can show now, whether they do, and the switch. */
export function useFestive() {
  const choice = useSyncExternalStore(subscribe, stored, () => null);
  const inSeason = isFestiveSeason() || choice === 'preview';
  const setOn = (on) => {
    try {
      localStorage.setItem(KEY, on ? 'on' : 'off');
    } catch (e) {
      // not remembered, but still switched for this page
    }
    window.dispatchEvent(new Event(CHANGED));
  };
  return { inSeason, on: inSeason && choice !== 'off', setOn };
}
